import { OptionsWithSteps, ProductOptions } from '@storefront/types/Product';
import { getRegularPrice } from '@storefront/utils/priceHandler';
import { BundleItemWithLowestPrice } from '../product-configuration.utils';

interface DeltaPriceArgs {
  prices: { totalPricePerMonth: number };
  selected_options: string[];
  bundleOptions: OptionsWithSteps;
  price: number;
}

export const calculateDeltaPrice = ({
  prices,
  selected_options,
  bundleOptions,
  price,
}: DeltaPriceArgs) => {
  const selectedOptionals = bundleOptions?.notRequiredOptions
    ?.flatMap((opt) => opt.options)
    .filter((option) => selected_options.includes(option.uid));

  const optionalsTotalPrice = selectedOptionals.length
    ? selectedOptionals.reduce(
        (acc, option) => acc + getRegularPrice(option),
        0
      )
    : 0;

  const deltaPrice = price - prices.totalPricePerMonth + optionalsTotalPrice;
  return deltaPrice;
};

export const removePaperOptions = (
  configs: ProductOptions,
  bundleOptions: OptionsWithSteps
) => {
  const selectedOptions = Object.values(configs);
  bundleOptions?.notRequiredOptions?.forEach(
    (option: BundleItemWithLowestPrice) => {
      const uid = option.options.find((opt) =>
        selectedOptions.includes(opt.uid)
      )?.uid;
      if (uid) {
        delete configs[option.uid];
      }
    }
  );
};
